import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './StaffManagement.css';

const tiles = [
  {
    icon: '👤',
    title: 'Add Staff',
    permissionKey: 'staffs.add',
    description: 'Create new staff accounts and manage permissions',
    url: 'add',
  },
  {
    icon: '👥',
    title: 'View Staffs',
    permissionKey: 'staffs.view',
    description: 'View all staff members and their details',
    url: 'view',
  },
  {
    icon: '🏷️',
    title: 'Manage Staff Types',
    permissionKey: 'staffs.manage_types',
    description: 'Create and manage different staff type categories',
    url: 'types',
  },
  {
    icon: '🔗',
    title: 'Staff - Complaint Type',
    permissionKey: 'staffs.complaint_mapping',
    description: 'Map complaint types to staff type categories',
    url: 'complaint-mapping',
  },
];

const StaffManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Manage Staffs"
        mainSection
        activePath={location.pathname}
      >
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              icon={tile.icon}
              title={tile.title}
              description={tile.description}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default StaffManagement;
